export enum BillOfMaterialsTemplateBindingStatus {
  Proposed = "proposed",
  Active = "active",
  Paused = "paused",
  Rejected = "rejected",
}
